import { AssetField } from '@elementary/common-ui/services/gql/types';

export const COLUMN_TO_FIELD_MAP: Record<string, AssetField> = {
  name: 'NAME',
  database_name: 'DATABASE_NAME',
  schema: 'SCHEMA_NAME',
  status: 'LAST_EXECUTION_STATUS',
  last_exec_time: 'LAST_EXECUTION_DURATION',
  median_exec_time: 'MEDIAN_DURATION',
  exec_time_change_rate: 'CHANGE_RATE',
  totals: 'ERROR_COUNT',
  'asset_metadata.owners': 'OWNER',
  'asset_metadata.tags': 'TAG',
  'asset_metadata.subscribers': 'SUBSCRIBER',
  'asset_metadata.materialization': 'BUILD_STRATEGY',
  'asset_metadata.is_critical': 'IS_CRITICAL',
  'asset_metadata.path': 'PATH',
};

export const FIELD_TO_COLUMN_MAP: Partial<Record<AssetField, string>> =
  Object.fromEntries(
    Object.entries(COLUMN_TO_FIELD_MAP).map(([column, field]) => [
      field,
      column,
    ]),
  );
